import Vue from "vue";
import App from "./App.vue";
import moment from "moment";
import VueMasonry from "@/components/vue-masonry-css/vue-masonry";
import VueLazyload from "vue-lazyload";
import "./css/app.scss";
const loadimage = require("@/assets/images/loading.png");
const errorimage = require("@/assets/images/loading.png")

Vue.use(VueMasonry);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
});
Vue.prototype.moment = moment;
new Vue({
  render: h => h(App)
}).$mount('#app');

